// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"0a7284f6","75":"6f286d51","676":"08357371","734":"677e3402","754":"d69b54bb","816":"6facf3ff","842":"89247f4d","877":"0f35069f","892":"ec7997ab","925":"148b22b0","963":"2efa51f0"}[chunkId] + ".chunk.js";
};